import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import routes from './routes'

function reduceRoles (roles) {
  const reducer = (routes, route) => {
    const routeRoles = route.roles || route.meta?.roles || []

    // NOTE if roles are undefined, generic access is assumed
    const granted = !routeRoles || routeRoles?.some(role => roles?.includes(role)) || (roles.includes('superadmin') || roles.includes('admin') && (!roles.includes('superadmin') && !routeRoles.includes('superadmin')))
    // console.log(routeRoles, granted, ' | ', routeRoles?.some(role => roles?.includes(role)), (roles.includes('superadmin') || roles.includes('admin') && (!roles.includes('superadmin') && !routeRoles.includes('superadmin'))))

    if (!granted && routeRoles?.length) return routes
    if (route.children) route.children = (route.children || []).reduce(reducer, [])

    routes.push(route)
    return routes
  }

  return reducer
}


export default function ({ store, ssrContext }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes: routes.static,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  Router.beforeEach(async (to, from, next) => {
    const authenticated = await store.dispatch('User/CheckAuthentication')

    // if the user auth / role has changed, recreate routes
    if (store.getters['User/ShouldGenerateRoutes']) {
      Router.addRoute({...routes.authedRoot, redirect: { name: routes.AUTHED_INDEX }, children: routes.authed.reduce(reduceRoles(store.getters['User/Roles']), [])})
      store.dispatch('User/GeneratedRoutes')
      if (to.path) next({ path: to.path, query: to.query })
      else if (to.name) next({ name: to.name })
      else next()
      return
    }

    if (to.matched.some(record => record.meta.requiresAuth) && !authenticated) {
      next({ name: 'Login' })
      return
    }

    // Remove suffix slashes from url
    if (to.path.length > 1 && to.path.endsWith('/')) {
      next({ name: to.name || '' })
      return
    }

    next()
  })

  return Router
}
